import React from 'react';
import clsx from 'clsx';
import Select, {
    components,
    DropdownIndicatorProps,
    ClearIndicatorProps,
    MultiValueRemoveProps,
    StylesConfig,
} from 'react-select';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import chroma from 'chroma-js';

// ICONS CATEGORIAS

import CallRoundedIcon from '@mui/icons-material/CallRounded';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import PersonPinCircleRoundedIcon from '@mui/icons-material/PersonPinCircleRounded';

const iconsData = [
    {
        icon: CallRoundedIcon,
    },
    {
        icon: Groups2RoundedIcon,
    },
    {icon: EmailRoundedIcon},
    {
        icon: Diversity3RoundedIcon,
    },
    {icon: SchoolRoundedIcon},
    {
        icon: MoreHorizRoundedIcon,
    },
    {
        icon: GavelRoundedIcon,
    },
    {
        icon: WorkHistoryRoundedIcon,
    },
    {
        icon: RecordVoiceOverRoundedIcon,
    },
    {
        icon: PersonPinCircleRoundedIcon,
    },
];

const DropdownIndicator = (props: DropdownIndicatorProps) => {
    return (
        <components.DropdownIndicator {...props}>
            <KeyboardArrowDownOutlinedIcon />
        </components.DropdownIndicator>
    );
};

const ClearIndicator = (props: ClearIndicatorProps) => {
    return (
        <components.ClearIndicator {...props}>
            <CloseIcon />
        </components.ClearIndicator>
    );
};

const MultiValueRemove = (props: MultiValueRemoveProps) => {
    return (
        <components.MultiValueRemove {...props}>
            <CloseIcon />
        </components.MultiValueRemove>
    );
};

const customOption = ({innerProps, label, data}) => (
    <div
        {...innerProps}
        className="custom-option cursor-pointer"
        style={{
            marginRight: '8px',
            color: data.cor,
        }}>
        <KeyboardArrowDownOutlinedIcon />
        {label}
    </div>
);

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        padding: '8px',
    }),
};

const controlStyles = {
    base: 'border rounded-[8px] bg-white hover:cursor-pointer dark:bg-gray-900',
    focus: 'border-blue-500 ring-1 ring-primary-500 dark:focus:ring-blue-500 ',
    nonFocus: 'border-gray-300 dark:border-gray-600',
};
const placeholderStyles = 'text-gray-900 dark:text-white pl-1 py-0.5';
const selectInputStyles = 'pl-1 py-0.5 dark:text-white  w-36 ';
const valueContainerStyles = 'p-1 gap-1 dark:text-white ';
const singleValueStyles = 'leading-7 ml-1 ';
const multiValueStyles =
    'bg-gray-100 rounded items-center py-0.5 pl-2 pr-1 gap-1.5 dark:text-white';
const multiValueLabelStyles = 'leading-6 py-0.5 ';
const multiValueRemoveStyles =
    'border border-gray-200 bg-white dark:bg-gray-600 hover:bg-red-50 hover:text-red-800 text-gray-500 dark:text-white hover:border-red-300 rounded-[4px]';
const indicatorsContainerStyles = 'p-1 gap-1 ';
const clearIndicatorStyles =
    'text-gray-500 p-1 rounded-[8px] hover:bg-red-50 hover:text-red-800';
const indicatorSeparatorStyles = 'bg-gray-300 ';
const dropdownIndicatorStyles =
    'p-1 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-white rounded-[8px] hover:text-black';
const menuStyles =
    'p-1 mt-2 border border-gray-200 dark:border-gray-600 bg-white dark:text-white dark:bg-gray-900 rounded-[8px]';
const groupHeadingStyles = 'ml-3 mt-2 mb-1 text-gray-500 dark:text-white';
const optionStyles = {
    base: 'hover:cursor-pointer px-3  rounded',
    focus: 'bg-blue-200 dark:bg-blue-500 active:bg-gray-200  dark:focus:border-blue-500',
    selected:
        "after:content-['✔'] after:ml-2 after:text-blue-500 dark:after:text-white text-gray-900 dark:text-white",
};
const noOptionsMessageStyles =
    'text-gray-500 p-2 bg-gray-50 dark:bg-gray-900 dark:border-gray-600 border border-dashed border-gray-200 rounded-[8px]';

const colourStyles = {
    base: 'hover:cursor-pointer px-3 rounded flex items-center',
    focus: 'bg-blue-200 dark:bg-blue-500 active:bg-gray-200 dark:focus:border-blue-500',
    selected:
        "after:content-['✔'] after:ml-2 after:text-blue-500 dark:after:text-white text-gray-900 dark:text-white",

    icon: {
        marginRight: '8px',
    },

    control: styles => ({
        ...styles,
        backgroundColor: 'white',
    }),
    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
        const color =
            data.cor && data.cor !== '' ? chroma(data.cor || '#4e5b8e') : null;

        return {
            ...styles,
            backgroundColor: isDisabled
                ? undefined
                : isSelected
                ? data.cor
                : isFocused
                ? color && color.alpha(0.1).css()
                : undefined,
            color: isDisabled
                ? '#ccc'
                : isSelected
                ? color && chroma.contrast(color, 'white') > 2
                    ? 'white'
                    : 'black'
                : data.cor,
            cursor: isDisabled ? 'not-allowed' : 'default',

            ':active': {
                ...styles[':active'],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? data.cor
                        : color && color.alpha(0.3).css()
                    : undefined,
            },
        };
    },
    multiValue: (styles, {data}) => {
        const color = chroma(data.cor || '#4e5b8e');
        return {
            ...styles,
            backgroundColor: color.alpha(0.1).css(),
        };
    },
    multiValueLabel: (styles, {data}) => ({
        ...styles,
        color: data.cor,
    }),
    multiValueRemove: (styles, {data}) => ({
        ...styles,
        color: data.cor,
        ':hover': {
            backgroundColor: data.cor,
            color: 'white',
        },
    }),
};

const ReactSelect = ({
    value,
    options,
    onChange,
    onInputChange,
    noOptionsMessage,
    isDisabled,
    placeholder,
    ...props
}) => (
    <Select
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        unstyled
        styles={{
            input: base => ({
                ...base,
                'input:focus': {
                    boxShadow: 'none',
                },
            }),
            multiValueLabel: base => ({
                ...base,
                whiteSpace: 'normal',
                overflow: 'visible',
            }),
            control: base => ({
                ...base,
                transition: 'none',
            }),
        }}
        components={{
            DropdownIndicator,
            ClearIndicator,
            MultiValueRemove,
            Option: customOption,
        }}
        classNames={{
            control: ({isFocused}) =>
                clsx(
                    isFocused ? controlStyles.focus : controlStyles.nonFocus,
                    controlStyles.base,
                ),
            placeholder: () => placeholderStyles,
            input: () => selectInputStyles,
            valueContainer: () => valueContainerStyles,
            singleValue: () => singleValueStyles,
            multiValue: () => multiValueStyles,
            multiValueLabel: () => multiValueLabelStyles,
            multiValueRemove: () => multiValueRemoveStyles,
            indicatorsContainer: () => indicatorsContainerStyles,
            clearIndicator: () => clearIndicatorStyles,
            indicatorSeparator: () => indicatorSeparatorStyles,
            dropdownIndicator: () => dropdownIndicatorStyles,
            menu: () => menuStyles,
            groupHeading: () => groupHeadingStyles,
            option: ({isFocused, isSelected}) =>
                clsx(
                    isFocused && optionStyles.focus,
                    isSelected && optionStyles.selected,
                    optionStyles.base,
                ),
            noOptionsMessage: () => noOptionsMessageStyles,
        }}
        value={value}
        options={options}
        onChange={onChange}
        onInputChange={onInputChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        noOptionsMessage={() => noOptionsMessage}
        {...props}
        isMulti
    />
);

function MultiSelectColor({
    value,
    options,
    onChange,
    onInputChange,
    noOptionsMessage,
    placeholder,
    isDisabled,
}) {
    const sortedOptions = Array.isArray(options)
        ? options.slice().sort((a, b) => a.label.localeCompare(b.label))
        : [];

    return (
        <ReactSelect
            value={value}
            options={sortedOptions}
            onChange={onChange}
            noOptionsMessage={noOptionsMessage}
            placeholder={placeholder}
            onInputChange={onInputChange}
            isDisabled={isDisabled}
            isMulti
            styles={colourStyles}
        />
    );
}

export default MultiSelectColor;
